// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_EnviarNotificacaoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /clientes/enviar-notificacao
 *
 * Staff-facing: sends one free-text message to a customer's portal inbox
 * (my.newshoes.com).
 *
 * Like its sibling Clientes_CriarAcessoPortalInput, the body carries only the
 * cliente_id. The document is deliberately NOT accepted from the client — it is
 * read from the cliente record the caller is allowed to see, so a caller cannot
 * message a document of their choosing. Notifications are addressed by document
 * and the portal shows them to the PERSON across every franchise, so this is
 * the guard that keeps "cross-franchise addressing" from becoming
 * "any attendant can message any CPF in Brazil".
 */
import { registerContract } from './validate'

export interface Clientes_EnviarNotificacaoInput {
cliente_id: number
mensagem: string
}

registerContract('Clientes_EnviarNotificacaoInput', {
  cliente_id: { type: 'number',  required: true },
  mensagem:   { type: 'string',  required: true },
})
